import React, { useRef } from 'react';
import Accordion from '../../atoms/Accordion';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import Styles from './FaqLPs25.css';
import { useLayout } from '@/utils/useLayout';

function FaqLPs25({
  classsection,
  faqtitle,
  imgpng,
  imgwebp,
  imgpngdesk,
  imgwebpdesk,
  imgalt,
  faqs = [],
  linkMostrarTodasPerguntas,
}) {
  const accRefs = useRef(faqs.map(() => React.createRef()));

  const handleAccChange = (index, open) => {
    if (!open) return;
    accRefs.current.forEach((ref, i) => {
      if (i !== index && ref.current) {
        ref.current.close();
      }
    });
  };

  const { width } = useLayout();

  return (
    <section id="perguntas" className={classsection}>
      <ContainerHome24>
        <div className="perguntas-contain">
          {width <= 992 && (
            <picture>
              <source type="image/webp" srcSet={imgwebp} />
              <source type="image/png" srcSet={imgpng} />
              <img src={imgpng} alt={imgalt} className="img-perguntas" />
            </picture>
          )}
          {width > 992 && (
            <picture>
              <source type="image/webp" srcSet={imgwebpdesk} />
              <source type="image/png" srcSet={imgpngdesk} />
              <img src={imgpngdesk} alt={imgalt} className="img-perguntas" />
            </picture>
          )}
          <div className="group-perguntas">
            <h2 className="title-perguntas">{faqtitle}</h2>
            {faqs.map((faq, index) => (
              <Accordion
                key={index}
                title={faq.pergunta}
                accordionRef={accRefs.current[index]}
                onChange={(open) => handleAccChange(index, open)}
                startOpen={faq.startOpen}
              >
                <p
                  dangerouslySetInnerHTML={{
                    __html: faq.resposta,
                  }}
                />
              </Accordion>
            ))}
            {linkMostrarTodasPerguntas && (
              <a href={linkMostrarTodasPerguntas} className="link-faq">
                Mostrar todas as perguntas
              </a>
            )}
          </div>
        </div>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default FaqLPs25;
